const setup = function() {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=places&callback=initMap' + CONFIGURATION.googleMapsKey;
  script.async = true;
  document.head.appendChild(script);
};

const GooglePlacesPort = {
  add: function(app) {
    setup();

    window.initMap = function() {
      app.ports.googlePlacesPredictAddress.subscribe(function({ address, id }) {
        if(!address) { return; }
        var service = new google.maps.places.AutocompleteService();
        var options = { input: address, types: ['address'] }
        service.getPlacePredictions(options, function(predictions, status) {
          app.ports.googlePlacesAddressPredictions.send({ predictions, id });
        });
      });

      app.ports.googlePlacesPredictionDetails.subscribe(function({ placeId, id }) {
        var request = { placeId: placeId };
        var service = new google.maps.places.PlacesService(document.createElement('div'));
        service.getDetails(request, function(place, status) {
          var address = JSON.stringify(place);
          app.ports.googlePlacesAddressDetails.send({ address, id });
        });
      });

      app.ports.googleRequestDistance.subscribe(function({ origin, destinations }) {
        if(origin && destinations) {
          var service = new google.maps.DistanceMatrixService();
          var destinationAddresses = destinations.map(d => d.address);
          var options = { origins: [ origin.address ],
            destinations: destinationAddresses,
            travelMode: 'DRIVING',
            unitSystem: google.maps.UnitSystem.IMPERIAL
          };

          service.getDistanceMatrix(options, function(response, status) {
            if (status == 'OK') {
              var results = [];

              for (var i = 0; i < response.rows.length; i++) {
                var rowResults = response.rows[i].elements;

                for (var j = 0; j < rowResults.length; j++) {
                  var element = rowResults[j];
                  if (element.status == 'OK') {
                    var distance = element.distance.value;
                    results.push({ address: destinations[j], distance: distance });
                  }
                }
              }

              app.ports.googleDistanceResults.send(results)
            }
          });
        }
      });
    };
  }
}

module.exports = GooglePlacesPort;
